import { render, staticRenderFns } from "./Clinic.vue?vue&type=template&id=0e682ea8&scoped=true&"
import script from "./Clinic.vue?vue&type=script&lang=js&"
export * from "./Clinic.vue?vue&type=script&lang=js&"
import style0 from "./Clinic.vue?vue&type=style&index=0&id=0e682ea8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e682ea8",
  null
  
)

export default component.exports